import { Component, Input } from "@angular/core";

@Component({
  selector: "app-callout",
  templateUrl: "./callout.component.html",
})
export class CalloutComponent {
  @Input() title = "";
  @Input() body = "";
}
